import Title from '../../@iosper/components/Page/Title';
import { MedicamentosMain } from '../pages';

export const Medicamentos = () => {
  return (
    <>
      <Title autoFocus={false}>Medicamentos</Title>
      <MedicamentosMain />
    </>
  );
};
